import { Navigate, Route, Routes } from "react-router-dom";
import { MainLayout } from "./Components/MainLayout";
import { Faq } from "./Components/Faq/Faq";
import { Contact } from "./Components/Contact_us/Contact";
import About from "./Components/About_us/About";
import Home from "./Components/Home/Home";
import MenuPage from "./Components/MenuPage/menupage";
import MenuDetails from "./Components/MenuDetails/menuDetails";
import Login from "./Components/Login/login";
import SignUp from "./Components/Signup/signup";
import VerifyOtp from "./Components/Verify_otp/verifyOtp";
import ForgotPassowrd from "./Components/Forgot_password/forgotpassword";
import Resetpassword from "./Components/Forgot_password/resetpassword";
import MakeOrder from "./Components/Order/makeOrder";
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel";
import MenuByCategory from "./Components/MenuByCategory/menubycategory";
import MyProfile from "./Components/Profile/myprofile";
import { useSelector } from "react-redux";
import ProtectedRoute from "./Components/Login/protectedroute";
import Payment from "./Components/Payments/payment";
import ErrorPage from "./Components/Pagenotfound/errorpage";
import Terms from "./Components/Common/Terms";
import SuccessPayment from "./Components/Payments/SuccessPayment";
import CancelPayment from "./Components/Payments/CancelPayment";
import ChangeOrder from "./Components/Order/ChangeOrder";
import PrivacyPolicy from "./Components/Privacy_policy/PrivacyPolicy";
import HerlevSeo from "./Components/Common/StaticSeoPages/HerlevSeo";
import SkolemadBallerup from "./Components/Common/StaticSeoPages/SkolemadBallerup";
import GladsaxeSkolemad from "./Components/Common/StaticSeoPages/GladsaxeSkolemad";
import SeoPage from "./Components/SeoPages/SeoPage";
import SeoCategory from "./Components/SeoPages/SeoCategory";
import NoIndex from "./Seo/NoIndex";
import SoborgSkolemad from "./Components/Common/StaticSeoPages/SoborgSkolemad";
import AuthSocketListener from "./Components/AuthSocketListener";
import Cookies from "js-cookie";
import SkolemadGlostrup from "./Components/Common/StaticSeoPages/SkolemadGlostrup";

function App() {
  const user = useSelector((state) => state.user);
  const token = Cookies.get("token");

  return (
    <div className="App">
      <AuthSocketListener token={token} />
      <Routes>
        <Route path="/" element={<MainLayout />}>
          <Route index element={<Home />} />
          <Route path="faq" element={<Faq />} />
          <Route path="contact" element={<Contact />} />
          <Route path="about" element={<About />} />
          <Route path="terms" element={<Terms />} />
          <Route path="privacy-policy" element={<PrivacyPolicy />} />
          {/* Static SEO pages */}
          <Route path="skolemad-herlev" element={<HerlevSeo />} />
          <Route path="skolemad-ballerup" element={<SkolemadBallerup />} />
          <Route path="skolemad-gladsaxe" element={<GladsaxeSkolemad />} />
          <Route path="skolemad-soborg" element={<SoborgSkolemad />} />
          <Route path="skolemad-glostrup" element={<SkolemadGlostrup />} />
          <Route path="menu" element={<MenuPage />} />
          <Route path="menuDetails/:idMenu" element={<MenuDetails />} />
          <Route
            path="menubyCategory/:idCategory"
            element={<MenuByCategory />}
          />

          {/* Location landing pages. These components already existed but were
              never routed — they were unreachable, and the navbar pointed at a
              /seo/index.html directory that has never existed in the build. */}
          <Route path="skolemad-herlev" element={<HerlevSeo />} />
          <Route path="skolemad-ballerup" element={<SkolemadBallerup />} />

          {/* Admin-managed SEO landing pages. The API and admin CRUD for these
              already existed; only the SPA routes were missing, so crawlers got
              a bot-only EJS render while users got the 404 page. */}
          <Route path="seo-pages/:slug" element={<SeoPage />} />
          <Route path="seo-category/:categorySlug" element={<SeoCategory />} />

          {/* Auth and transactional routes. <NoIndex> emits noindex/nofollow
              plus a canonical, so none of these can be indexed even though some
              are prerendered for load speed. */}
          <Route
            path="login"
            element={
              user && user.user && user.user.status ? (
                <Navigate to="/myprofile" />
              ) : (
                <NoIndex>
                  <Login />
                </NoIndex>
              )
            }
          />
          <Route
            path="signup"
            element={
              <NoIndex>
                <SignUp />
              </NoIndex>
            }
          />
          <Route
            path="verifyOtp"
            element={
              <NoIndex>
                <VerifyOtp />
              </NoIndex>
            }
          />
          <Route
            path="forgot-password"
            element={
              <NoIndex>
                <ForgotPassowrd />
              </NoIndex>
            }
          />
          <Route
            path="reset-password"
            element={
              <NoIndex>
                <Resetpassword />
              </NoIndex>
            }
          />
          <Route
            path="make-order"
            element={
              <NoIndex>
                <MakeOrder />
              </NoIndex>
            }
          />
          <Route
            path="change-order"
            element={
              <NoIndex>
                <ChangeOrder />
              </NoIndex>
            }
          />
          <Route path="myprofile" element={<ProtectedRoute />}>
            <Route
              index
              element={
                <NoIndex>
                  <MyProfile />
                </NoIndex>
              }
            />
          </Route>
          <Route
            path="make-payment"
            element={
              <NoIndex>
                <Payment />
              </NoIndex>
            }
          />
          <Route
            path="payment-success"
            element={
              <NoIndex>
                <SuccessPayment />
              </NoIndex>
            }
          />
          <Route
            path="payment-cancel"
            element={
              <NoIndex>
                <CancelPayment />
              </NoIndex>
            }
          />
        </Route>
        <Route
          path="*"
          element={
            <NoIndex title="Siden blev ikke fundet | Onlineskolemad">
              <ErrorPage />
            </NoIndex>
          }
        />
      </Routes>
    </div>
  );
}

export default App;
